import http from '@/utils/http';
const baseUrl = '/raio-permitido-por-estado-rastreabilidade';

export default {
    findAll() {
        return http.get({
            url: baseUrl,
            lockScreen: true
        });
    }
};
